/**
 * Convert an array of strings to an object with the same keys and values.
 * @param arr - The array of strings to convert.
 * @returns An object with the same keys and values.
 */
export const asConst = <T extends readonly string[]>(arr: T) => {
  return Object.fromEntries(arr.map((value) => [value, value])) as { [K in T[number]]: K }
}

/**
 * Convert an object to an array of key-value pairs with typed keys.
 * @param obj - The object to convert.
 * @returns An array of key-value pairs with typed keys.
 */
export function typedEntries<T extends object>(obj: T): [keyof T, T[keyof T]][] {
  return Object.entries(obj) as [keyof T, T[keyof T]][]
}
